const PUBLIC_STRING = 'p=1';

const createPath = (location) => {
  const { origin, pathname, search = '', hash = '' } = location;

  const resourcePath = pathname.split('#')[0];

  return `${origin}${resourcePath}${search}${hash}`;
};

const getSharingUrl = ({ shareUrl, location, isPublic



}) => {
  if (!isPublic) {
    return shareUrl || createPath(location);
  }

  if (shareUrl) {
    return shareUrl.indexOf('?') === -1 ?
    `${shareUrl}?${PUBLIC_STRING}` :
    `${shareUrl}&${PUBLIC_STRING}`;
  }

  const { search = '' } = location;

  const newSearch = search ? `${search}&${PUBLIC_STRING}` : `?${PUBLIC_STRING}`;

  return createPath({ ...location, search: newSearch });
};

export default getSharingUrl;